// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3Ryln","selected":"Chip_selected__rgSGC"};